import React from 'react';
import { RetrieveRequest } from '../../../utilities/services/RequestService';
import { getOptionsDeactive } from '../../../utilities/actions/Helpers';
import { Alert } from '../..';
import SelectBase from './SelectBase';
import { api } from '../../../config/Services';

class AirportSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            options: []
        }
    }

    componentDidMount() {
        if (this.props.forceRender) {
            this.retrieveData();
        }
    }

    retrieveData(criteria = {}, fieldinactive = {}, actionspage = 'create') {
        let paging = { limit: -1, page: 1 }
        let sort = { cityname: 'asc' };
        let url = api.url.masterdata.airport.retrieve;
        criteria.active = true;
        let column = [];
        this.setState({ isLoading: true });
        RetrieveRequest(url, criteria, sort, paging, column).then((response) => {
            const { status = {} } = response || {};
            if (status.responsecode === '0000') {
                var options = response.result.map(({ cityname, airportiatacode, airportname }) => {
                    return {
                        label: `${cityname} (${airportiatacode}), ${airportname}`,
                        value: airportiatacode
                    };
                });

                let { airportiatacode, cityname, airportname } = fieldinactive;
                let airportLabel = cityname + " (" + airportiatacode + "), " + airportname;
                if (airportiatacode) {
                    options = getOptionsDeactive(actionspage, options, airportiatacode, airportLabel);
                }

                this.setState({ options, isLoading: false });
            } else {
                Alert.error(response.status.responsemessage);
            }
        });
    }

    render() {
        return (<SelectBase {...this.props} options={this.state.options} isLoading={this.state.isLoading} />)
    }

}

export default AirportSelect;